import TatvamPagination from "./tatvamPagination";

export default TatvamPagination;